import request from '@/utils/request'

export function pager(data) {
  return request({
    url: '/api/processRest/list',
    method: 'post',
    data,
  })
}

export function doAdd(data) {
  return request({
    url: '/api/processRest/',
    method: 'post',
    data,
  })
}

export function doEdit(data) {
  return request({
    url: '/api/processRest/',
    method: 'put',
    data,
  })
}

export function doDelete(data) {
  return request({
    url: '/api/processRest/' + data,
    method: 'delete',
  })
}
